export type UploadedImage = {
  url: string;
  filename: string;
  mimeType: string;
  size: number;
};

export async function uploadChatImage(
  apiBase: string,
  conversationId: string,
  token: string,
  file: File,
): Promise<UploadedImage> {
  const formData = new FormData();
  formData.append("image", file);
  const response = await fetch(`${apiBase}/v1/conversations/${conversationId}/images/upload`, {
    method: "POST",
    headers: { authorization: `Bearer ${token}` },
    body: formData,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message ?? "No se pudo subir la imagen");
  }
  return {
    url: body.url as string,
    filename: body.filename as string,
    mimeType: (body.mimeType as string) || file.type,
    size: Number(body.size) || file.size,
  };
}
